import { render, staticRenderFns } from "./InspectionLink.vue?vue&type=template&id=24732a91&scoped=true"
import script from "./InspectionLink.vue?vue&type=script&lang=js"
export * from "./InspectionLink.vue?vue&type=script&lang=js"
import style0 from "./InspectionLink.vue?vue&type=style&index=0&id=24732a91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24732a91",
  null
  
)

export default component.exports